import * as React from "react";

/** Bottom nav home icon (house outline, no fill) */
export const IconNavHome = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.00008 22.1667H10.5001V15.1667H17.5001V22.1667H21.0001V11.6667L14.0001 6.41667L7.00008 11.6667V22.1667ZM4.66675 24.5V10.5L14.0001 3.5L23.3334 10.5V24.5H15.1667V17.5H12.8334V24.5H4.66675Z"
      fill="currentColor"
    />
  </svg>
);
